import LatestBlogs from "../components/blog/LatestBlogs";
import Productlistcard from "../components/Productlistcard";
import Productslideshow from "../components/Productslideshow";
import FaqPage from "./FaqPage";

export const Home = () => {
  
  return (
    <div className="">
      <div className="container mx-auto mt-2">
        <h2 className="text-2xl md:text-2xl font-bold mb-4 text-center uppercase">Meet our new launch</h2>
        <Productslideshow showproduct={'sun-freeze-sunscreen-spf-50-pa++++'}/>
      </div>
      
      <div className="container mx-auto mt-2">
        <Productlistcard />
      </div>
      
      <div className="container mx-auto mt-2">
        <h2 className="text-2xl md:text-2xl font-bold mb-4 text-center uppercase">Meet our BestSeller</h2>
        <Productslideshow showproduct={'charcoal-nose-strips-for-blackheads'}/>
      </div>
      <LatestBlogs/>
      <FaqPage/>
    </div>
  );
};